<template>
    <div>
        <el-form
            :model="formData"
            ref="formData"
            label-position="top"
            :rules="rules"
            v-loading="dataLoading"
        >
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="cover" label="封面:" :show-message="formData.cover ? false : true">
                        <image-upload 
                            :url.sync="formData.cover" 
                            :urlFull.sync="formData.cover" 
                            :crop="true"
                            :min-width="750"
                            :min-height="1334"
                            ref="posterUpload"
                            class="poster-upload"
                        >
                            <span slot="size">建议宽高比9:16,不小于750px*1334px</span>
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                    <el-form-item prop="status" label="状态:">
                        <el-radio-group v-model="formData.status" size="medium">
                            <el-radio :label="1">启用</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="展位设置:">
                        <el-checkbox v-model="formData.isSelect" :true-label="1" :false-label="0" size="medium">设为发现页精选</el-checkbox>
                        <el-checkbox v-model="formData.isSpecial" :true-label="1" :false-label="0" size="medium">设为特刊</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="名称:">
                        <el-input v-model="formData.name" placeholder="请输入频道名称" size="medium" maxlength="40"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="backgroundColor" label="背景色:">
                        <el-input v-model="formData.backgroundColor" placeholder="请输入背景颜色" size="medium" maxlength="20"></el-input>
                        <el-color-picker v-model="formData.backgroundColor" size="medium"></el-color-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="describe" label="描述:">
                        <el-input v-model="formData.describe" placeholder="请输入描述" type="textarea" autosize maxlength="100"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="videoIds">
                        <span slot="label">绑定视频: <small>请输入视频ID进行查找,点击添加进行绑定</small></span>
                        <el-input v-model="queryId" class="input-with-select" placeholder="请输入视频ID" size="medium">
                            <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                        </el-input>
                        <template v-if="videoList && videoList.length > 0">
                            <el-table
                                class="sortable"
                                :data="videoList"
                                border
                                style="width: 100%"
                                size="small"
                                v-loading="listLoading"
                                row-key="videoId"
                            >
                                <el-table-column prop="videoId" label="视频ID"></el-table-column>
                                <el-table-column prop="videoName" label="视频名称"></el-table-column>
                                <el-table-column prop="display" label="状态">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.display == 1" type="success" size="mini">展示</el-tag>
                                        <el-tag v-else type="info" size="mini">隐藏</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            size="small"
                                            icon="el-icon-remove"
                                            @click="del(scope.$index)"
                                            >解绑</el-button
                                        >
                                    </template>
                                </el-table-column>
                            </el-table>
                            <small class="from-tip"><span class="el-icon-warning"></span> 按住鼠标可拖动排序</small>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-group-box MT10">
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnLoading">提交</el-button>
        </div>
    </div>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
import Sortable from "sortablejs";
const defaultFormData = {
    cover: '',
    describe: '',
    name: '',
    status: 1,
    videoIds: [],
    backgroundColor: '',
    isSelect: 0,
    isSpecial: 0,
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components:{ImageUpload},
    data(){

        return {
            formData:{...defaultFormData},
            rules:{
                name: [{ required: true, message: "请输入名称" }],
                describe: [{ required: true, message: "请输入描述" }],
                cover: [{ required: true, message: "请上传封面" }],
                backgroundColor: [{ required: true, message: "请输入背景颜色" }],
                videoIds: [{ required: true, message: "请选择绑定的视频" }],
            },
            btnLoading: false,
            dataLoading: false,
            redirect: this.$route.query.redirect || '',
            reFresh:false,
            queryId:'',
            videoList: [],
            listLoading: false
        }
    },
    mounted(){
        if (this.id) {
            this.getData();
        }else{
            this.reFresh = true;
        }
    },
    methods:{
        // 获取详情
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/channel/info",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...defaultFormData,
                        ...result,
                    }
                    this.videoList = result.videoVOS || [];
                    this.setVideoIds();
                    this.drag(); 
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                    this.reFresh = true;
                });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.setVideoIds();
                    this.$request({
                        url: "/channel/save",
                        method: "POST",
                        data: {
                            ...this.formData,
                            // isSelect: !this.formData.isSelect ? 0 : this.formData.isSelect,
                            // isSpecial: !this.formData.isSpecial ? 0 : this.formData.isSpecial,
                        }
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //搜索视频
        searchEvent(){
            if (this.queryId !== "") {
                this.listLoading = true;
                this.$request({
                    url: "/video/getPageList",
                    method: "POST",
                    data: { queryValue: this.queryId,queryType:2, pageNo:1, pageSize:100 },
                }).then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        const _list = result.result || [];
                        if(_list && _list.length > 0){
                            _list.map(item => {
                                const _obj = this.videoList ? this.videoList.find(v => v.videoId === item.id) : null
                                if( !_obj ){
                                    this.videoList.push({
                                        ...item,
                                        videoName: item.name,
                                        videoId: item.id
                                    }) ;
                                }
                            })
                        }else{
                            return this.$message.error("没有找到相关视频");
                        }
                        this.queryId = '';
                        this.setVideoIds();
                        this.drag(); 
                    } else {
                        return this.$message.error(msg || "获取视频失败");
                    }
                })
                    .catch(() => {
                        this.$message.error("获取视频失败,请重试");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            }
        },
        setVideoIds(){
            this.formData.videoIds = [];
            this.videoList.map(item => {
                this.formData.videoIds.push(item.videoId);
            })
        },
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable> .el-table__body-wrapper > table > tbody')[0];
                Sortable.create(el, {
                    disabled: false, // 拖拽不可用? false 启用
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    onEnd: (e) => { // 拖拽结束时的触发
                        let arr = this.videoList; // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        this.$nextTick(() => {
                            this.videoList = arr;
                        })
                    },
                });
            })
        },
        del(index){
            this.videoList = this.videoList.filter((v,i) => i !== index);
            this.setVideoIds();
        }
    }
}
</script>

<style lang="scss" scoped>
.poster-upload{
    ::v-deep .image{
        width: 160px;
        height: 160px;
    }
    ::v-deep .image-upload-content{
        height: 160px;
    }
}
.el-color-picker{
    position: absolute;
    right: 0;
    top: 2px;
}
</style>